
import { Vue } from "nuxt-property-decorator"
import { mapGetters } from "vuex"
import { GET_PHONE_NUMBER_VALUE } from "~/store/phone-number/getters"
import { LINK_PHONE } from "~/constants/blocks"

export default Vue.extend({
  name: "AvLinkPhone",
  data() {
    return {
      globalStylingClass: LINK_PHONE
    }
  },
  props: {
    block: { required: true, type: Object as () => Block },
    linkOnly: { type: Boolean, default: false }
  },
  computed: {
    ...mapGetters("phone-number", {
      phone_getPhoneNumberValue: GET_PHONE_NUMBER_VALUE
    }),
    hasIcon() {
      return !this.linkOnly
    }
  },
  methods: {
    handleClick(phoneNumber: string, extension: string) {
      this.$snowplow.trackCallUs({
        phoneNumber,
        label: "Phone link",
        extension,
        action: "click"
      })
    }
  }
})
